class RxHubFailsComponent {
  constructor(Orders) {
    Object.assign(this, {
      Orders,
      fails: [],
    });
  }
}

RxHubFailsComponent.$inject = ['Orders'];
angular.module('pims').component('rxHubFailsTable', {
  templateUrl: 'app/views/visits/list/tabs/rx-hub/table/fails/rx-hub-fails.component.html',
  controller: RxHubFailsComponent,
  controllerAs: 'vm',
  bindings: {
    fails: '='
  }
});
